import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { Gtp } from 'src/app/shared/gtp';

import { UsuariosTablaComponent } from '../usuarios-tabla/usuarios-tabla.component';
import { UsuariosService } from 'src/app/services/admin/usuarios/usuarios.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {

  public loading: boolean = false;
  public isDisabledUser: boolean = false;

  public alertFail: boolean = false;
  public alertSuccess: boolean = false;
  public alertAccess: boolean = false;

  public alertMsg: string = '';
  public vertabla: boolean = false;
  public verForm: boolean = false;

  public editar: boolean = false;
  public cancelar: boolean = false;
  public guardar: boolean = true;

  showPassword: boolean = false;

  usuario = {
    nombre: '',
    current: '',
    password: '',
    perfil: ''
  }

  tipoPerfilFiltered=[
    {id: 3, nombre:'Operario'},
    {id: 2, nombre:'Administrador'},
    {id: 5, nombre:'Limitado'}

  ]

  constructor(
    private router: Router,
    private gtp: Gtp,
    private usuarioCall:UsuariosService

  ) { }

  ngOnInit(): void {
    this.cargarFormData();
      let user = this.gtp.getUserDataParse();
      //console.log(user)
      if (user['perfil']!=="ADMINISTRADOR") {
          this.alertAccess=true
          this.alertMsg='DEBE TENER UN PERFIL ADMINISTRADOR'
      } else {
        this.verForm = true
      }
  }

  onNameChange(editing: boolean) {
    console.log(editing); // Imprime el nuevo nombre
  }

  loadInforme(){
    this.usuarioCall.getUsuariosListar().subscribe(res => {
      //console.log(res)
      this.usuarioCall.setContenidoTabla(res['usuarios'])
    });

  }

  closeMovil(){
    this.gtp.setAdminSidebar(true);
  }

  getUsuarioSelected(e){
    this.usuario.perfil=e.id
  }

  cargarFormData(){
    this.usuarioCall.getFormDataObs().subscribe(res => {
       console.log(res)
      if (res['usuario']=='') {
        this.isDisabledUser = false
      }else{
        this.isDisabledUser = true
        this.guardar=false
        this.editar=true
        this.cancelar=true
        this.usuario.nombre = res.usuario
        this.usuario.perfil = res.cod_perfil
      }
    });
  }

  doGuardar(){
    this.loading = true;

    if (this.usuario.nombre === '' || this.usuario.current === '' || this.usuario.password === '' || this.usuario.perfil === '') {
      this.alertFail = true;
      this.alertMsg = 'Ingrese los datos necesarios para el registro';
    }else{
        this.usuarioCall.usuarioGuardar(this.usuario).subscribe(res => {
          console.log(res)

          this.alertSuccess = true;
          this.alertMsg = 'USUARIO REGISTRADO';
        },(error)=>{
            //console.log(error);
            this.loading = false;
            this.alertFail = true;
            this.alertMsg = error;
          });

    }

    setTimeout(() => {
      //this.showAlertMsg = false;
      this.doCancelar()
      this.alertSuccess = false;
      this.alertFail = false;
      this.loading = false;

      this.loadInforme()

    }, 2000)
  }

  doEditar(){

    this.usuarioCall.usuarioEditar(this.usuario).subscribe(res => {
      console.log(res)

      this.alertSuccess = true;
      this.alertMsg = 'USUARIO ACTUALIZADO';
    },(error)=>{
        //console.log(error);
        this.loading = false;
        this.alertFail = true;
        this.alertMsg = error;
      });

      setTimeout(() => {
        //this.showAlertMsg = false;
        this.doCancelar()
        this.alertSuccess = false;
        this.alertFail = false;
        this.loading = false;

        this.loadInforme()
      }, 2000)
  }

  doCancelar(){
      this.isDisabledUser = false
      this.guardar=true
      this.editar=false
      this.cancelar=false

      this.usuario.nombre= ''
      this.usuario.current= ''
      this.usuario.password= ''
      this.usuario.perfil= ''
  }

  toggleTable(e){
    //console.log(e)
    this.vertabla = e.checked
    if ( this.vertabla) {
      this.gtp.setMainOutlet(UsuariosTablaComponent);
    } else {
      this.gtp.setMainOutlet(false);
    }
  }

  showPass() {
    this.showPassword = !this.showPassword;
  }
}
